

interface ChargeCounterProps {
  label: string
  count: number
  maxCount: number
}

export function ChargeCounter({ label, count, maxCount }: ChargeCounterProps) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 4,
      fontSize: 12,
      color: count > 0 ? '#b0bec5' : '#546e7a',
    }}>
      <span>{label}:</span>
      <span style={{ fontWeight: 600 }}>{count}/{maxCount}</span>
    </div>
  )
}
